<div cdkDrag cdkDragBoundary=".cdk-overlay-container"
     cdkDragRootElement=".dialog-box.password">
  <div cdkDragHandle mat-dialog-title>
    <mat-icon>key</mat-icon>
    <h1>{{ globals.titles.password }}</h1>
    <app-close-button [data]="closeData"></app-close-button>
  </div>
  <mat-dialog-content>
    <form [formGroup]="page.form">
      <mat-form-field [appearance]="globals.appearance" [formGroup]="page.form">
        <mat-label>{{ page.controls['pwdOld'].label }}</mat-label>
        <input [type]="hide ? 'password' : 'text'" autofocus formControlName="pwdOld" matInput/>
      </mat-form-field>
      <mat-form-field [appearance]="globals.appearance" [formGroup]="page.form">
        <mat-label>{{ page.controls['pwdNew'].label }}</mat-label>
        <input [type]="hide ? 'password' : 'text'" formControlName="pwdNew" matInput/>
      </mat-form-field>
      <mat-form-field [appearance]="globals.appearance" [formGroup]="page.form">
        <mat-label>{{ page.controls['pwdRep'].label }}</mat-label>
        <input [type]="hide ? 'password' : 'text'" formControlName="pwdRep" matInput/>
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button (click)="clickSave()" i18n mat-button>
      <mat-icon>save</mat-icon>
      Save
    </button>
    <button
      (click)="hide = !hide"
      [attr.aria-label]="'Hide password'"
      [attr.aria-pressed]="hide"
      mat-icon-button
      matSuffix
      type="button">
      <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>
  </mat-dialog-actions>
</div>
